import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import { Product, useProductsQuery } from '../apollo/api';
import Bookcase from '../ui-components/Bookcase';
import BookcaseSection from '../ui-components/BookcaseSection';
import LibraryItem from '../ui-components/LibraryItem';

export default function Resources() {
  const { loading, error, data } = useProductsQuery();

  const resources = (data?.productInstances ?? []).reduce(
    (resources: Record<string, Pick<Product, 'id' | 'description' | 'img_url'>[]>, r) => {
      const p = r.product!;
      if (!p.id.startsWith('PSX')) {
        return resources;
      }
      const c = p.categories.find((c) => c.primary_cat) ?? p.categories[0];
      return c ? { ...resources, [c.name]: [...(resources[c.name] ?? []), p] } : resources;
    },
    {}
  );

  const categories = Object.keys(resources).sort((a, b) => a.localeCompare(b));

  return (
    <>
      <div className="Library-header">
        <Link to="/library">Libreria</Link>
        <h1>Risorse</h1>
      </div>

      {loading && <p>Caricamento...</p>}

      {error && <Alert message={error.message} type="error" showIcon />}

      {data && (
        <Bookcase higher>
          {categories.map((c) => (
            <BookcaseSection title={c} key={c}>
              {resources[c]!.map((p) => (
                <LibraryItem product={p} key={p.id} />
              ))}
            </BookcaseSection>
          ))}
        </Bookcase>
      )}
    </>
  );
}
